import { render, staticRenderFns } from "./advertisement-edit.vue?vue&type=template&id=2f91dd96&scoped=true&"
import script from "./advertisement-edit.vue?vue&type=script&lang=js&"
export * from "./advertisement-edit.vue?vue&type=script&lang=js&"
import style0 from "./advertisement-edit.vue?vue&type=style&index=0&id=2f91dd96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f91dd96",
  null
  
)

export default component.exports